'use client';

// Re-export everything from the auth wrapper
export type { UserInfo, AuthState, AuthUser } from './auth/types';
export { AuthProvider, useAuth, useFirebaseAuth } from './auth/AuthProviderWrapper';
